/**
 * Horizon Pro — Scroll Progress Bar
 * Shows a progress bar at the top of the page indicating scroll position
 */
(function () {
  const bar = document.querySelector('.hp-scroll-progress__bar');
  if (!bar) return;

  function updateProgress() {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    bar.style.width = progress + '%';
  }

  window.addEventListener('scroll', updateProgress, { passive: true });
  updateProgress();
})();
